// @flow
import { useSelector } from 'react-redux';
import type { TGridBreakpointName } from '@graphite/types';

const useCurrentDevice: () => TGridBreakpointName = () => useSelector(state => state.editor.currentDevice || 'desktop');

export default useCurrentDevice;
